import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  partnerDetailContainer: {
    marginBottom: theme.spacing(4),
  },
  partnerOption: {
    marginBottom: theme.spacing(0.75),
    fontFamily: theme.typography.h5.fontFamily,
  },
  partnerDetails: {
    marginLeft: theme.spacing(0.5),
  },
  partnerDetail: {
    marginBottom: theme.spacing(0.5),
    whiteSpace: 'pre-line',
  },
  detailLabel: {
    color: theme.palette.common.gray800,
    fontFamily: theme.typography.h4.fontFamily,
  },
  detailValue: {
    color: theme.palette.common.gray800,
  },
  externalLinkIcon: {
    marginLeft: theme.spacing(1),
  },
  // Sits under the package heading and above its rows: it describes the package
  // rather than any one row. The wording carries the state, so the color on the
  // expired reading is emphasis and never the only signal.
  validity: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.75),
  },
  validityExpired: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(0.75),
  },
  // This theme defines no `warning`, so MUI's own orange stands in and measures 2.16:1 on white,
  // which fails AA for normal text.
  missingRehire: {
    color: theme.palette.common.orange800,
    marginBottom: theme.spacing(0.75),
  },
  detailMeta: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
  },
  modalRoot: {
    background: 'rgba(0, 0, 0, 0.1)',
  },
  topSection: {
    '&.reducedPadding': {
      padding: 0,
    },
  },
  modalContent: {
    width: '90%',
    height: '80%',
    borderRadius: '5px',
  },
  iframeModal: {
    display: 'flex',
    flexDirection: 'column',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
}));

export default useStyles;
